import { ConfigProvider } from "antd";

ConfigProvider.config({
    theme: {
        primaryColor: "#507FFB",
        borderRadiusBase: "8px",
    },
});